var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "order-view" },
    [
      _c(
        "div",
        { staticClass: "ov-head" },
        [
          _c(
            "a-tabs",
            {
              staticClass: "ov-tabs",
              attrs: { size: "small" },
              on: { change: _vm.onTabChange },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("a-tab-pane", { key: "all", attrs: { tab: "全部" } }),
              _c("a-tab-pane", { key: "dine_in", attrs: { tab: "堂食" } }),
              _c("a-tab-pane", { key: "fastfood", attrs: { tab: "快餐" } }),
              _c("a-tab-pane", { key: "takeout", attrs: { tab: "外卖" } }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ov-filters" },
            [
              _c(
                "a-select",
                {
                  staticStyle: { width: "140px" },
                  on: { change: _vm.reload },
                  model: {
                    value: _vm.queryStatus,
                    callback: function ($$v) {
                      _vm.queryStatus = $$v
                    },
                    expression: "queryStatus",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "" } }, [
                    _vm._v("全部状态"),
                  ]),
                  _vm._l(_vm.currentStatusOptions, function (s) {
                    return _c(
                      "a-select-option",
                      { key: s.value, attrs: { value: s.value } },
                      [_vm._v(_vm._s(s.label))]
                    )
                  }),
                ],
                2
              ),
              _c("a-range-picker", { on: { change: _vm.onDateChange } }),
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    icon: "search",
                    loading: _vm.loading,
                  },
                  on: { click: _vm.reload },
                },
                [_vm._v("查询")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ov-body" },
        [
          _c("a-table", {
            attrs: {
              columns: _vm.currentColumns,
              "data-source": _vm.rows,
              loading: _vm.loading,
              rowKey: "id",
              size: "middle",
              pagination: _vm.pagination,
              scroll: { x: 1080 },
            },
            on: { change: _vm.handleTableChange },
            scopedSlots: _vm._u([
              {
                key: "tableNo",
                fn: function (text, record) {
                  return [
                    record.call_no
                      ? _c("span", { staticClass: "ov-callno" }, [
                          _vm._v("取餐号 " + _vm._s(record.call_no)),
                        ])
                      : _c("span", [_vm._v(_vm._s(record.tableName || "-"))]),
                  ]
                },
              },
              {
                key: "amount",
                fn: function (text) {
                  return [
                    _c("span", { staticClass: "ov-amount" }, [
                      _vm._v("¥" + _vm._s(_vm.fmt(text))),
                    ]),
                  ]
                },
              },
              {
                key: "status",
                fn: function (text, record) {
                  return [
                    record.state !== undefined
                      ? _c(
                          "a-tag",
                          {
                            attrs: {
                              color: _vm.takeoutStatusColor(record.state),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                record.stateText ||
                                  _vm.takeoutStatusText(record.state)
                              )
                            ),
                          ]
                        )
                      : _c(
                          "a-tag",
                          { attrs: { color: _vm.statusColor(record.status) } },
                          [
                            _vm._v(
                              _vm._s(
                                record.statusText ||
                                  _vm.statusText(record.status)
                              )
                            ),
                          ]
                        ),
                  ]
                },
              },
              {
                key: "action",
                fn: function (text, record) {
                  return [
                    record.state !== undefined
                      ? [
                          _c(
                            "a-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.showTakeoutDetail(record)
                                },
                              },
                            },
                            [_vm._v("详情")]
                          ),
                          _vm.canTakeoutReceive(record)
                            ? _c(
                                "a-button",
                                {
                                  staticClass: "act-btn",
                                  attrs: {
                                    size: "small",
                                    type: "primary",
                                    loading: _vm.takeoutOpId === record.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTakeoutOp(
                                        record,
                                        "receive"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("接单")]
                              )
                            : _vm._e(),
                          _vm.canTakeoutMealOut(record)
                            ? _c(
                                "a-button",
                                {
                                  staticClass: "act-btn",
                                  attrs: {
                                    size: "small",
                                    loading: _vm.takeoutOpId === record.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTakeoutOp(
                                        record,
                                        "mealOut"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("出餐")]
                              )
                            : _vm._e(),
                          _vm.canTakeoutComplete(record)
                            ? _c(
                                "a-button",
                                {
                                  staticClass: "act-btn",
                                  attrs: {
                                    size: "small",
                                    loading: _vm.takeoutOpId === record.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleTakeoutOp(
                                        record,
                                        "complete"
                                      )
                                    },
                                  },
                                },
                                [_vm._v("完成")]
                              )
                            : _vm._e(),
                          _vm.canTakeoutVerify(record)
                            ? _c(
                                "a-button",
                                {
                                  staticClass: "act-btn",
                                  attrs: { size: "small", type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openVerify(record)
                                    },
                                  },
                                },
                                [_vm._v("自提核销")]
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              staticClass: "act-btn",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.showTakeoutPrint(record)
                                },
                              },
                            },
                            [_vm._v("打印")]
                          ),
                        ]
                      : [
                          _c(
                            "a-button",
                            {
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.showDetail(record)
                                },
                              },
                            },
                            [_vm._v("详情")]
                          ),
                          _vm.canReceive(record)
                            ? _c(
                                "a-button",
                                {
                                  staticClass: "act-btn",
                                  attrs: {
                                    size: "small",
                                    type: "primary",
                                    loading: _vm.receivingId === record.id,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReceive(record)
                                    },
                                  },
                                },
                                [_vm._v("接单")]
                              )
                            : _vm._e(),
                          record.status === "3" && _vm.canRefund
                            ? _c(
                                "a-popconfirm",
                                {
                                  attrs: { title: "确认整单退款？" },
                                  on: {
                                    confirm: function ($event) {
                                      return _vm.handleRefund(record)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "a-button",
                                    {
                                      staticClass: "act-btn",
                                      attrs: { size: "small", type: "danger" },
                                    },
                                    [_vm._v("退款")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _c(
                            "a-button",
                            {
                              staticClass: "act-btn",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.showPrint(record)
                                },
                              },
                            },
                            [_vm._v("打印")]
                          ),
                        ],
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.detailVisible,
            title: "订单详情",
            footer: null,
            width: "760px",
          },
          on: {
            cancel: function ($event) {
              _vm.detailVisible = false
            },
          },
        },
        [
          _vm.detailData
            ? [
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("订单号")]),
                    _vm._v(_vm._s(_vm.detailData.order_no)),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("状态")]),
                    _vm._v(
                      _vm._s(
                        _vm.detailData.statusText ||
                          _vm.statusText(_vm.detailData.status)
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("业态")]),
                    _vm._v(_vm._s(_vm.businessText(_vm.detailData))),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("桌台/取餐号")]),
                    _vm._v(
                      _vm._s(
                        _vm.detailData.call_no
                          ? "取餐号 " + _vm.detailData.call_no
                          : _vm.detailData.tableName || "-"
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("会员")]),
                    _vm._v(_vm._s(_vm.detailData.memberName || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("人数")]),
                    _vm._v(
                      _vm._s(
                        _vm.detailData.person_count ||
                          _vm.detailData.people ||
                          "-"
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("消费方式")]),
                    _vm._v(
                      _vm._s(
                        _vm.detailData.is_out === "2" ? "打包带走" : "店内就餐"
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("收银员")]),
                    _vm._v(
                      _vm._s(
                        _vm.detailData.operatorName ||
                          _vm.detailData.creatorName ||
                          "-"
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("下单时间")]),
                    _vm._v(_vm._s(_vm.detailData.create_time || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("结算时间")]),
                    _vm._v(_vm._s(_vm.detailData.settle_time || "-")),
                  ]),
                ]),
                _c("a-table", {
                  attrs: {
                    columns: _vm.itemColumns,
                    "data-source": _vm.detailData.items || [],
                    rowKey: "id",
                    size: "small",
                    pagination: false,
                    scroll: { y: 240 },
                  },
                }),
                _c("div", { staticClass: "detail-amounts" }, [
                  _c("div", { staticClass: "da-row" }, [
                    _c("span", [_vm._v("商品合计")]),
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s(_vm.fmt(_vm.detailData.total_amount))
                      ),
                    ]),
                  ]),
                  Number(_vm.detailData.service_money) > 0
                    ? _c("div", { staticClass: "da-row" }, [
                        _c("span", [_vm._v("服务费")]),
                        _c("span", [
                          _vm._v(
                            "¥" + _vm._s(_vm.fmt(_vm.detailData.service_money))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  Number(_vm.detailData.tableware_money) > 0
                    ? _c("div", { staticClass: "da-row" }, [
                        _c("span", [_vm._v("打包费")]),
                        _c("span", [
                          _vm._v(
                            "¥" +
                              _vm._s(_vm.fmt(_vm.detailData.tableware_money))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  Number(_vm.detailData.discount_amount) > 0
                    ? _c("div", { staticClass: "da-row" }, [
                        _c("span", [_vm._v("会员优惠")]),
                        _c("span", [
                          _vm._v(
                            "-¥" +
                              _vm._s(_vm.fmt(_vm.detailData.discount_amount))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  Number(_vm.detailData.erase_amount) > 0
                    ? _c("div", { staticClass: "da-row" }, [
                        _c("span", [_vm._v("抹零")]),
                        _c("span", [
                          _vm._v(
                            "-¥" + _vm._s(_vm.fmt(_vm.detailData.erase_amount))
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "da-row da-pay" }, [
                    _c("span", [_vm._v("实收")]),
                    _c("span", [
                      _vm._v("¥" + _vm._s(_vm.fmt(_vm.detailData.pay_amount))),
                    ]),
                  ]),
                  _c("div", { staticClass: "da-row" }, [
                    _c("span", [_vm._v("支付方式")]),
                    _c("span", [_vm._v(_vm._s(_vm.payText(_vm.detailData)))]),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.takeoutDetailVisible,
            title: "外卖订单详情",
            footer: null,
            width: "760px",
          },
          on: {
            cancel: function ($event) {
              _vm.takeoutDetailVisible = false
            },
          },
        },
        [
          _vm.takeoutDetailData
            ? [
                _c("div", { staticClass: "detail-grid" }, [
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("订单号")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.orderNo)),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("状态")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.stateText)),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("方式")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.deliveryModeText)),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("取单号")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.takeNo || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("自提码")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.selfCode || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("预约时间")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.reserveTime || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("出餐状态")]),
                    _vm._v(
                      _vm._s(
                        _vm.takeoutDetailData.mealOutState === "1"
                          ? "已出餐"
                          : "未出餐"
                      )
                    ),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("下单时间")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.createTime || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("支付时间")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.settleTime || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("接单时间")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.receiptAt || "-")),
                  ]),
                  _c("div", { staticClass: "d-item" }, [
                    _c("span", { staticClass: "d-k" }, [_vm._v("完成时间")]),
                    _vm._v(_vm._s(_vm.takeoutDetailData.completeAt || "-")),
                  ]),
                ]),
                _vm.takeoutDetailData.address
                  ? _c("div", { staticClass: "to-addr" }, [
                      _c("div", { staticClass: "to-addr-title" }, [
                        _vm._v("收货地址"),
                      ]),
                      _c("div", { staticClass: "to-addr-line" }, [
                        _vm._v(
                          _vm._s(_vm.takeoutAddrContact) +
                            " " +
                            _vm._s(_vm.takeoutDetailData.address.phone)
                        ),
                      ]),
                      _c("div", { staticClass: "to-addr-line" }, [
                        _vm._v(_vm._s(_vm.takeoutAddrText)),
                      ]),
                    ])
                  : _vm._e(),
                _vm.takeoutDetailData.remark
                  ? _c("div", { staticClass: "to-remark" }, [
                      _vm._v("备注：" + _vm._s(_vm.takeoutDetailData.remark)),
                    ])
                  : _vm._e(),
                _c("a-table", {
                  attrs: {
                    columns: _vm.takeoutItemColumns,
                    "data-source": _vm.takeoutDetailData.items || [],
                    rowKey: "materialName",
                    size: "small",
                    pagination: false,
                    scroll: { y: 200 },
                  },
                }),
                _c("div", { staticClass: "detail-amounts" }, [
                  _c("div", { staticClass: "da-row" }, [
                    _c("span", [_vm._v("商品合计")]),
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s(_vm.fmt(_vm.takeoutDetailData.goodsAmount))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "da-row" }, [
                    _c("span", [_vm._v("配送费")]),
                    _c("span", [
                      _vm._v(
                        "¥" +
                          _vm._s(_vm.fmt(_vm.takeoutDetailData.deliveryAmount))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "da-row" }, [
                    _c("span", [_vm._v("包装费")]),
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s(_vm.fmt(_vm.takeoutDetailData.boxAmount))
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "da-row da-pay" }, [
                    _c("span", [_vm._v("实收")]),
                    _c("span", [
                      _vm._v(
                        "¥" + _vm._s(_vm.fmt(_vm.takeoutDetailData.payAmount))
                      ),
                    ]),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "to-timeline" },
                  [
                    _c("div", { staticClass: "to-timeline-title" }, [
                      _vm._v("订单进度"),
                    ]),
                    _vm._l(_vm.takeoutTimeline, function (s, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "to-step",
                          class: { done: s.done },
                        },
                        [
                          _c("span", { staticClass: "to-step-dot" }),
                          _c("span", { staticClass: "to-step-text" }, [
                            _vm._v(_vm._s(s.text)),
                          ]),
                          _c("span", { staticClass: "to-step-time" }, [
                            _vm._v(_vm._s(s.time || "")),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.verifyVisible,
            title: "自提核销",
            okText: "核销",
            cancelText: "取消",
            confirmLoading: _vm.takeoutOpId === _vm.verifyTargetId,
          },
          on: {
            ok: _vm.handleVerify,
            cancel: function ($event) {
              _vm.verifyVisible = false
            },
          },
        },
        [
          _vm.verifyTarget
            ? _c("div", { staticClass: "verify-tip" }, [
                _vm._v(
                  "订单 " +
                    _vm._s(_vm.verifyTarget.orderNo) +
                    "（" +
                    _vm._s(_vm.verifyTarget.stateText) +
                    "）"
                ),
              ])
            : _vm._e(),
          _c("a-input", {
            attrs: { placeholder: "请输入顾客出示的自提码", maxlength: "12" },
            on: { pressEnter: _vm.handleVerify },
            model: {
              value: _vm.verifyCode,
              callback: function ($$v) {
                _vm.verifyCode = $$v
              },
              expression: "verifyCode",
            },
          }),
        ],
        1
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.printVisible,
            title: "厨打 / 结账单数据",
            footer: null,
            width: "560px",
          },
          on: {
            cancel: function ($event) {
              _vm.printVisible = false
            },
          },
        },
        [
          _c("pre", { staticClass: "print-pre" }, [
            _vm._v(_vm._s(_vm.printText)),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }